<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0">
                <h3 class="page-title">Adjust sub IDs in outbound links</h3>
            </div>
        </div>
        <!-- Second Row of Posts -->
        <d-row>
            <d-col lg="12">
                <d-card >
                    <d-card-header class="border-bottom">
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-domain' }">1. Add website</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-network' }">2. Connect networks</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-intergration' }">3. Connect integrations</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'snippet' }">4. Place Ivanhoe.io tag</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'affiliate-link' }">5. Choose direct or cloaked links</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><u>6. Ready to start</u></h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>
                    <d-card-body>
                        <div class="col">
                            <div class="card card-small mt-4 mb-4">
                                <div class="card-body p-0 pb-3 text-center">
                                    <table class="table mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th scope="col" class="border text-left">Network</th>
                                                <th scope="col" class="border text-left">Extension</th>
                                                <th scope="col" class="border text-left d-none d-xl-block">Example url</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="border text-left">Daisycon</td>
                                                <td class="border text-left">DC=</td>
                                                <td class="border text-left d-none d-xl-block">https://example.com/?{{ getUrl('dc') }}=IVANHOE</td>
                                            </tr>
                                            <tr>
                                                <td class="border text-left">AWIN</td>
                                                <td class="border text-left">AW=</td>
                                                <td class="border text-left d-none d-xl-block">https://example.com/?{{ getUrl('aw') }}=IVANHOE</td>
                                            </tr>
                                            <tr>
                                                <td class="border text-left">Bol.com</td>
                                                <td class="border text-left">BC=</td>
                                                <td class="border text-left d-none d-xl-block">https://example.com/?{{ getUrl('bc') }}=IVANHOE</td>
                                            </tr>
                                            <tr>
                                                <td class="border text-left">Affiliate pro</td>
                                                <td class="border text-left">AP=</td>
                                                <td class="border text-left d-none d-xl-block">https://example.com/?{{ getUrl('ap') }}=IVANHOE</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </d-card-body>
                    <d-card-footer>
                        <d-row>
                            <d-col class="d-flex justify-content-start">
                                <d-link tag="button" :to="{ name: 'affiliate-link' }" class="btn btn-secondary">Previous step</d-link>
                            </d-col>
                            <d-col class="d-flex justify-content-end">
                                <d-link tag="button" :to="{ name: 'network' }" class="btn btn-success">Done</d-link>
                            </d-col>
                        </d-row>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
export default {
    data() {
        return {
            percent: 100,
        };
    },
    methods: {
        // Emulate api call
        getUrl(network) {
            return network;
        },
    },
};
</script>
